import { Amount, Unit } from 'uom';
import { Units, UnitTimes } from 'uom-units';

// Squared is not exported from the lib but is useful so pasted here
export const Squared = (name, u) => UnitTimes.lengthByLength(name, u, u);
// custom uoms
export const SquaredKilometer = Squared('SquareKilometer', Units.Kilometer);
export const SquareMile = Squared('SquareMile', Units.Mile);
export const Hectare = Unit.timesNumber('Hectare', 10000, Units.SquareMeter);
export const Acre = Unit.timesNumber('Acre', 4046.86, Units.SquareMeter);

export const ZERO_SF = Amount.create(0, Units.SquareFeet);

/**
 * Definition of supported uoms
 */
export const UOMS = {
  // lengths / distances
  FOOT: {
    type: 'length',
    unit: Units.Foot,
    aliases: ['foot', 'feet', 'ft'],
  },
  INCHES: {
    type: 'length',
    unit: Units.Inch,
    aliases: ['in', 'inches', 'inch'],
  },
  METER: {
    type: 'length',
    unit: Units.Meter,
    aliases: ['meter', 'mt', 'mts', 'meters'],
  },
  KILOMETER: {
    type: 'length',
    unit: Units.Kilometer,
    aliases: ['kilometer', 'kilometers', 'km', 'kms'],
  },
  MILE: {
    type: 'length',
    unit: Units.Mile,
    aliases: ['mile', 'ml', 'milla', 'miles'],
  },
  // areas
  SQUARE_FOOT: {
    type: 'area',
    unit: Units.SquareFeet,
    aliases: ['sf', 'square foot', 'sqf', 'sf', 'square feet'],
  },
  SQUARE_METER: {
    type: 'area',
    unit: Units.SquareMeter,
    aliases: [`sm`, 'square meter', 'square meters', 'sqm', 'sqmt', 'sqmts', 'square mt'],
  },
  SQUARE_KILOMETER: {
    type: 'area',
    unit: SquaredKilometer,
    aliases: ['skm', 'square kilometers', 'square kilometers', 'sqkm', 'sqkms', 'square km'],
  },
  SQUARE_MILE: {
    type: 'area',
    unit: SquareMile,
    aliases: ['sml', 'square mile', 'square miles', 'sqml', 'sqmile'],
  },
  ACRE: {
    type: 'area',
    unit: Acre,
    aliases: ['acre', 'acres', 'acr', 'ac'],
  },
  HECTARE: {
    type: 'area',
    unit: Hectare,
    aliases: ['hectarea', 'hec', 'hectare', 'ha'],
  },
};
